module.exports = require('./helpers/bundle-url').getBundleURL('5ijCj') + "pentest.8c0b9765.jpg";